module.exports = __webpack_public_path__ + "static/media/jess lohse_1669922283286.ac272e60.jpg";